"use strict";

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var modules_1 = require("./modules");

var providers_1 = require("./providers");

var Query = /*#__PURE__*/function () {
  function Query(innerProvider) {
    _classCallCheck(this, Query);

    this.currentProvider = new providers_1.RootProvider();
    this.eth = new modules_1.Eth(this);
    this.net = new modules_1.Net(this);
    this.subscription = new modules_1.Subscription(this);

    if (typeof innerProvider === 'string') {
      innerProvider = innerProvider;

      switch (innerProvider.slice(0, 2)) {
        case 'ht':
          innerProvider = new providers_1.HttpProvider(innerProvider);
          break;

        case 'ws':
          innerProvider = new providers_1.WebSocketProvider(innerProvider);
          break;
      }
    }

    if (!innerProvider) {
      throw Error('invalid provider');
    }

    this.currentProvider.innerProvider = innerProvider;

    if (!Query.defaultInstance) {
      Query.defaultInstance = this;
    }
  }

  _createClass(Query, [{
    key: "send",
    value: function send(method) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var request, response, id, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Query.REQUEST_COUNTER += 1;
                request = {
                  method: method,
                  params: params,
                  jsonrpc: Query.JSON_RPC_VERSION,
                  id: Query.REQUEST_COUNTER
                };
                _context.next = 4;
                return this.currentProvider.sendAsync(request);

              case 4:
                response = _context.sent;
                id = response.id, result = response.result;

                if (!(id !== request.id)) {
                  _context.next = 8;
                  break;
                }

                throw new Error('invalid response');

              case 8:
                return _context.abrupt("return", result);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return Query;
}();

exports.Query = Query;
Query.defaultInstance = null;
Query.JSON_RPC_VERSION = '2.0';
Query.REQUEST_COUNTER = Date.now();